import HeaderBar from '@/components/headerbar';
import qs from 'query-string';
import { useEffect, useRef, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import Home from './pages/home/index';
import Edit from './pages/edit/index';
import Upload from './upload';
import { myContext } from './context-manager';
import Constant from './constant';
import { getNewImage } from '@/services/rpc/review';
import { useTranslation } from 'react-i18next';
import { Dialog, Toast } from 'antd-mobile';
import Lottie from '@/components/lottie';
import axios from 'axios';

const Review = () => {
  const { image = '', itemId, skuId } = qs.parse(window.location.search);
  const [cover, setCover] = useState<string>(Constant.defaultUrl);
  const [isShow, setIsShow] = useState<boolean>(true);
  const { t } = useTranslation();
  const lottieRef = useRef<any>(null);

  const obj = {
    image,
    cover,
    setCover
  };
  useEffect(() => {

    if(!image) {
      setIsShow(false);
      return;
    }
    // setCover('https://order-refund.hhocool.com/638e696f-41cb-43d7-a266-d1fa3dd64932.png');
    // setIsShow(false);
    // http://127.0.0.1:4000/review.html?hho_nav_bar=1&image=https://n-order-refund.oss-ap-southeast-1.aliyuncs.com/c6e89ec5fd9376efba183edd47ca0034.jpg?x-oss-process=image/format,webp,image/resize,w_400&itemId=P22XJ2233102#/edit/172/372
    getNewImage(image).then((res: any) => {
      setCover(res?.base64Image || res?.imageURL);
      setIsShow(false);
      Toast.clear();
    }).catch(()=>{
      const result = Dialog.show({
        content: "We found an error. It may be that the image size is too large or there is a network anomaly",
        actions: [
          [
            {
              key: 'close',
              text: 'Refresh',
              onClick: () => {
                location.reload();
              }
            },
            {
              key: 'Change Image',
              text: 'Change Image',
              style:{ color: 'rgb(238,126,49)'},
              onClick:  () =>{
                location.href = `${location.origin}/review.html#/upload?itemId=${qs.parse(location.search).itemId ||'P22XJ2233102'}&skuId=${qs.parse(location.search).skuId || 'SP22XJ2233102U'}`
              }
            }
          ]
        ]
      });
    });
    console.log(innerWidth);
    
  }, []);
  return (
    <myContext.Provider value={obj}>
      <div className='hho-cus-review'>
        {isShow && (
          <div className='loading-bg'>
            <Lottie
              ref={lottieRef}
              play={true}
              url='https://static.hhocool.com/files/cb21dd0e-f767-4245-a274-db47796a6060_loading-white.json'
            ></Lottie>
          </div>
        )}
        {!isShow && (
          <Routes>
            <Route path='/upload' element={<Upload/>}></Route>
            <Route path='/' element={<Home itemId={itemId} />} />
            <Route path='/edit' element={<Edit itemId={itemId} skuId={skuId} />} />
          </Routes>
        )}
      </div>
    </myContext.Provider>
  );
};

export default Review;
